import { render, staticRenderFns } from "./FArticleCategTable.vue?vue&type=template&id=627f0d8e&scoped=true"
import script from "./FArticleCategTable.vue?vue&type=script&lang=js"
export * from "./FArticleCategTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627f0d8e",
  null
  
)

export default component.exports